import { Button, Col, Form, Modal, Row, Select, Spin, Table, message } from "antd";
import COLORS from "common/Colors";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import React, { useEffect, useState } from "react";
import { useUpdate } from "hooks/useUpdate";
import { ButtonFilled } from "reusableComponent/UIButtons";
import styled from "styled-components";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { CALL_API } from "common/API";
import { Grade, STATUS_CODE } from "common/Constants";
import moment from "moment";
import { EditChargeOut } from "./EditChargeOut";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { connect, useDispatch, useSelector } from "react-redux";
import { getClientid, getCountryList } from "redux/selectors";
import { setChargeoutRatesList, setUserList } from "redux/actions";
import { bindActionCreators } from "redux";

const StyledModal = styled(Modal)`
  .ant-form-item {
    margin-bottom: "12px";
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledhistoryTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table {
    max-height: 350px;
    overflow-y: auto;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledButton = styled(Button)`
  width: 150px;
  color: #fff !important;
  background-color: #00685F;
  border-color: #00685F;
  border-radius: 5px;
  margin-left: 5%;
  &:hover,
  &:focus,
  &:active,
  &.active {
	background-color: #00685F !important;
	border-color: #00685F !important;
	color: #fff !important;
  }
`;

const CancelButton = styled(Button)`
  background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;

  &:hover,
  &:focus,
  &:active {
	background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
  }
`;

const StyledActionButton = styled(Button)`
  color: #00685F !important;
  background-color: #deefee;
  border-color: #deefee;
  border-radius: 5px;
  margin-left: 5%;
  &:hover,
  &:focus,
  &:active,
  &.active {
	color: #00685F !important;
  background-color: #deefee;
  border-color: #deefee;
  }
`;

function ChargeoutRates({ updateUserList, ClientId }) {
	const apiCountryList = useSelector(getCountryList);
	const [isEdit, setIsEdit] = useState(false);
	const [isHistory, setIsHistory] = useState(false);
	const [isAdd, setIsAdd] = useState(false);
	const [addForm] = Form.useForm();
	const [recordValue, setRecordValue] = useState({});
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [deleteRecord, setDeleteRecord] = useState(null);
	const [warningModalOpen, setWarningModalOpen] = useState(false);
	const [warningMessage, setWarningMessage] = useState("");
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setRecordValue({});
	}, []);

	const fetchMasterData = async (fetch_master_data) => {
		const { code, userList } = await CALL_API(
			`master-data/${ClientId}`,
			"post",
			{
				fetch_master_data,
			}
		);
		if (code === STATUS_CODE.SUCCESS) {
			updateUserList(userList);
		}
	};

	const { key, url } = queryKeys.getChargeoutRates;
	const { key: historyKey, url: historyUrl } =
		queryKeys.getHistoryChargeoutRates(recordValue?.chargeoutid);
	const { data, isLoading, refetch } = useFetch(key, url);

	const { data: historyData, isLoading: isLoadingHistory } = useFetch(
		historyKey,
		historyUrl,
		{
			enabled: isHistory,
		}
	);

	let historyDataSource = historyData?.response?.items?.filter(
		(val) => val?.countrycode === recordValue?.country
	);

	const refetchAndSyncRedux = async () => {
		refetch();
		const token = window.localStorage.getItem("token");
		const { jwtDecode } = await import("jwt-decode");
		const clientId = jwtDecode(token)?.clientId;

		const { chargeOutData } = await CALL_API(
			`master-data/userdetails?clientid=${clientId}`,
			"GET",
			{ fetch_master_userdata: true }
		);
		dispatch(setChargeoutRatesList(chargeOutData || []));
	};

	const updateChargeoutRate = async (id, payload) => {
		try {
			setLoading(true);
			const response = await CALL_API(
				`settings/chargeout/${id}`,
				"patch",
				payload
			);

			if (response.code === STATUS_CODE.SUCCESS) {
				message.success("Successfully Updated");
				setLoading(false);
				setIsEdit(false);
				refetch();
				fetchMasterData(true);
				await refetchAndSyncRedux();
			} else {
				message.error(
					`Update failed: ${response.message || "please try again."}`
				);
				setLoading(false);
				setIsEdit(false);
			}
		} catch (error) {
			message.error("An error occurred: " + error.message);
		} finally {
		}
	};

	const handleDelete = (record) => {
		setDeleteRecord(record);
		setDeleteModalOpen(true);
	};

	const confirmDelete = async () => {
		try {
			const response = await CALL_API(
				`settings/chargeout/${deleteRecord?.chargeoutid}`,
				"delete"
			);

			if (response?.code === STATUS_CODE.SUCCESS) {
				message.success("Chargeout rate deleted successfully");
				refetch();
				await refetchAndSyncRedux();
				setDeleteModalOpen(false);
			} else if (response?.message) {
				setDeleteModalOpen(false);
				setWarningMessage(response.message);
				setWarningModalOpen(true);
			} else {
				message.error("Failed to delete chargeout rate");
			}
		} catch (error) {
			message.error("Error deleting: " + error.message);
		}
	};

	const handleAddSubmit = async (values) => {
		try {
			setLoading(true);

			const selectedCountry = countries.find((c) => c.code === values.countrycode);

			const payload = {
				...values,
				rate: Number(values.rate),
				countrycode: values.countrycode,
				countryid: selectedCountry?.id,
				standard: Number(values.standard),
				targetchargeability: Number(values.targetchargeability),
			};
			const response = await CALL_API("settings/chargeout", "post", payload);
			if (response?.code === STATUS_CODE.SUCCESS) {
				message.success("Chargeout rate added successfully");
				setIsAdd(false);
				addForm.resetFields();
				await refetchAndSyncRedux();
			} else if (response?.code === "ALREADY_EXISTS") {
				message.error(response?.message || "This job grade code and country code combination already exists");
			} else {
				message.error(response?.message || "Failed to add");
			}
		} catch (error) {
			message.error("Error adding: " + error.message);
		} finally {
			setLoading(false);
		}
	};

	const handleFormSubmit = (values) => {
		const id = recordValue.chargeoutid;
		const isTitleEdited = values.jobgrade !== recordValue.jobgrade;
		const isDesignationEdited = values.designation !== recordValue.designation;
		let payload = {
			[recordValue.country]: values.rate,
			exception: recordValue.exception,
			jobgrade: values.jobgrade,
			jobgradecode: values.jobgradecode,
			designation: values.designation,
			standard: values.standard,
			targetchargeability: values.targetchargeability,
			rate: values.rate,
			countrycode: recordValue.country,
			countryid: values.countryid ?? recordValue.countryid,
			edittitle: isTitleEdited ? true : false,
			editdesignation: isDesignationEdited ? true : false,
		};
		updateChargeoutRate(id, payload);
	};

	const historyColumns = [
		{
			title: "Job Grade Code",
			dataIndex: "jobgradecode",
			key: "jobgradecode",
			align: "left",
			render: (text) => {
				return text || "-";
			},
		},
		{
			title: "Job Grade Title",
			dataIndex: "jobgrade",
			key: "jobgrade",
			align: "left",
			render: (text) => {
				return text || "-";
			},
		},
		{
			title: "Designation",
			dataIndex: "designation",
			key: "designation",
			align: "left",
			render: (text) => {
				return text || "-";
			},
		},
		{
			title: "Target Chargeability",
			dataIndex: "targetchargeability",
			key: "targetchargeability",
			align: "left",
			render: (text) => (text ? `${text}%` : "-"),
		},
		{
			title: "Standard",
			dataIndex: "standard",
			key: "standard",
			align: "left",
			render: (text) => (text ? `$${text}` : "-"),
		},
		{
			title: "Rate",
			dataIndex: "rate",
			key: "rate",
			align: "left",
			render: (text) => (text ? `$${text}` : "-"),
		},
		{
			title: "Updated At",
			dataIndex: "updatedat",
			key: "updatedat",
			render: (updatedat) => moment(updatedat).format("DD-MM-YYYY") || "-",
		},
	];

	const ellipsisStyle = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150, display: "block" };

	const columns = [
		{
			title: "Job Grade Code",
			dataIndex: "jobgradecode",
			key: "jobgradecode",
			render: (text) => <span style={ellipsisStyle} title={text || "-"}>{text || "-"}</span>,
		},
		{
			title: "Job Grade Title",
			dataIndex: "jobgrade",
			key: "jobgrade",
			render: (text) => <span style={ellipsisStyle} title={text || "-"}>{text || "-"}</span>,
		},
		{
			title: "Designation",
			dataIndex: "designation",
			key: "designation",
			render: (text) => <span style={ellipsisStyle} title={text || "-"}>{text || "-"}</span>,
		},
		{
			title: "Charge Out Rate",
			dataIndex: "rate",
			key: "rate",
			render: (text) => <span style={ellipsisStyle} title={text ? `$ ${text}` : "-"}>{text ? `$ ${text}` : "-"}</span>,
		},
		{
			title: "Target Chargeability",
			dataIndex: "targetchargeability",
			key: "targetchargeability",
			render: (text) => <span style={ellipsisStyle} title={text ? `${text}%` : "-"}>{text ? `${text}%` : "-"}</span>,
		},
		{
			title: "Standard",
			dataIndex: "standard",
			key: "standard",
			render: (text) => <span style={ellipsisStyle} title={text ? `$ ${text}` : "-"}>{text ? `$ ${text}` : "-"}</span>,
		},
		{
			title: "Country",
			dataIndex: "country",
			key: "standard",
			render: (text) => <span style={ellipsisStyle} title={text ? ` ${text}` : "-"}>{text ? ` ${text}` : "-"}</span>,
		},
		{
			title: "Action",
			dataIndex: "type_of_work",
			key: "type_of_work",
			render: (_, record) => (
				<div className="d-flex">
					<StyledActionButton
						onClick={() => {
							setIsEdit(true);
							setRecordValue(record);
						}}
					>
						Edit
					</StyledActionButton>
					<StyledActionButton
						onClick={() => {
							setIsHistory(true);
							setRecordValue(record);
						}}
					>
						History
					</StyledActionButton>
					<StyledActionButton
						onClick={() => handleDelete(record)}
					>
						Delete
					</StyledActionButton>
				</div>
			),
		},
	];

	const customLocale = {
		emptyText: <div>"No history data"</div>,
	};

	const [form] = Form.useForm();

	const countries = apiCountryList.map((c) => ({ code: c.countrycode, country: c.countryname, id: c.countryid, }));

	const allResponseData = data?.response?.items
		?.map((item) => {
			const countryMeta = countries.find((c) => c.code === item.countrycode) || {};
			return {
				jobgradecode: item.jobgradecode,
				targetchargeability: item.targetchargeability,
				standard: item.standard,
				country: item.countrycode,
				countryName: countryMeta.country,
				countryid: item.countryid ?? countryMeta.id,
				rate: item.rate,
				typeofwork: item.typeofwork,
				designation: item.designation,
				exception: item.exception,
				jobgrade: item.jobgrade,
				revenueKPI: item.revenueKPI,
				chargeoutid: item?.id,
			};
		})
		?.sort((a, b) => {
			if (a.countryName < b.countryName) return -1;
			if (a.countryName > b.countryName) return 1;

			const gradeA = Grade.indexOf(a.jobgradecode);
			const gradeB = Grade.indexOf(b.jobgradecode);

			return (
				(gradeA === -1 ? Number.MAX_SAFE_INTEGER : gradeA) -
				(gradeB === -1 ? Number.MAX_SAFE_INTEGER : gradeB)
			);
		});

	const allData = allResponseData
		? allResponseData?.map((item, index) => ({
			...item,
			id: index + 1,
		}))
		: [];

	useEffect(() => {
		setFilteredData(getFilteredData());
	}, [data]);

	const [filteredData, setFilteredData] = useState(allData);

	const headerstyle = { fontSize: "20px", fontWeight: "bold" };

	const getFilteredData = () => {
		const values = form.getFieldsValue();
		const grade = values.grade || [];
		const country = values.country || [];

		if (grade.length === 0 && country.length === 0) return allData;

		return allData.filter(
			(item) =>
				(grade.length === 0 || grade.includes(item.jobgradecode)) &&
				(country.length === 0 || country.includes(item.country))
		);
	};

	const gradeOptions = [
		...new Map(
			allData
				.filter((item) => item.jobgradecode)
				.map((item) => [item.jobgradecode, { label: item.jobgradecode, value: item.jobgradecode }])
		).values(),
	];

	const countryOptions = countries.map((c) => ({
		label: c.country,
		value: c.code,
	}));
	return (
		<>
			<Row className="page-title">
				<Col sm={24} md={12} style={headerstyle}>
					List of Chargeout Grade
				</Col>
				<Col sm={24} md={12} className="align-right">
					<ButtonFilled onClick={() => { setIsAdd(true); addForm.resetFields(); }}>
						Add New
					</ButtonFilled>
				</Col>
			</Row>

			<Form
				form={form}
				layout="vertical"
				className="mt-2"
				onValuesChange={() => setFilteredData(getFilteredData())}
			>
				<Row gutter={16}>
					<Col xs={24} sm={8}>
						<DropdownCheckBox
							name="grade"
							label="Grade"
							options={gradeOptions}
							form={form}
							handleFormChange={() => {
								form.setFieldsValue({ grade: [] });
								setFilteredData(getFilteredData());
							}}
						/>
					</Col>

					{/* <Col xs={24} sm={8}>
						<DropdownCheckBox
							name="country"
							label="Country"
							options={countryOptions}
							form={form}
							handleFormChange={() => {
								form.setFieldsValue({ country: [] });
								setFilteredData(getFilteredData());
							}}
						/>
					</Col> */}
				</Row>
			</Form>

			<Spin spinning={isLoading}>
				<StyledTable
					dataSource={filteredData}
					columns={columns}
					rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
					rowKey="id"
					pagination={false}
				/>
			</Spin>

			<EditChargeOut
				isEdit={isEdit}
				setIsEdit={setIsEdit}
				setRecordValue={setRecordValue}
				loading={loading}
				recordValue={recordValue}
				handleFormSubmit={handleFormSubmit}
				isLoading={isLoading}
			/>
			<StyledModal
				title="Chargeout Rates History"
				width={900}
				open={isHistory}
				footer={false}
				onCancel={() => setIsHistory(false)}
			>
				<Spin spinning={isLoadingHistory}>
					<StyledhistoryTable
						columns={historyColumns}
						dataSource={historyDataSource?.length > 0 ? historyDataSource : []}
						rowClassName={(record, index) =>
							index % 2 === 0 ? "" : "non-white"
						}
						rowKey={(record) => record.key}
						pagination={false}
						locale={customLocale}
					/>
				</Spin>
			</StyledModal>
			<StyledModal
				title="Add Chargeout Rate"
				width={600}
				open={isAdd}
				centered
				onCancel={() => {
					setIsAdd(false);
					addForm.resetFields();
				}}
				footer={[
					<CancelButton
						key="cancel"
						style={{ width: 130, height: 34, borderRadius: 8 }}
						onClick={() => {
							setIsAdd(false);
							addForm.resetFields();
						}}
					>
						Cancel
					</CancelButton>,
					<StyledButton
						key="add"
						loading={loading}
						style={{
							width: 130,
							height: 34,
							borderRadius: 8,
							backgroundColor: "#00685F",
							borderColor: "#00685F",
						}}
						onClick={() => addForm.submit()}
					>
						Add
					</StyledButton>,
				]}
			>
				<Form form={addForm} layout="vertical" onFinish={handleAddSubmit}>
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item
								name="jobgradecode"
								label="Job Grade Code"
								rules={[{ required: true, message: "Required" }]}
							>
								<input className="ant-input" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="jobgrade" label="Job Grade Title" rules={[{ required: true, message: "Required" }]}>
								<input className="ant-input" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="designation" label="Designation" rules={[{ required: true, message: "Required" }]}>
								<input className="ant-input" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								name="countrycode"
								label="Country"
								rules={[{ required: true, message: "Required" }]}
							>
								<Select
									placeholder="Select country"
									options={countryOptions}
									showSearch
									optionFilterProp="label"
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="rate" label="Charge Out Rate($)" rules={[{ required: true, message: "Required" }]}>
								<input className="ant-input" type="number" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="standard" label="Standard($)" rules={[{ required: true, message: "Required" }]}>
								<input className="ant-input" type="number" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								name="targetchargeability"
								label="Target Chargeability (%)"
								rules={[
									{ required: true, message: "Required" },
									{
										validator: (_, value) => {
											if (!value && value !== 0) return Promise.resolve();
											const num = parseFloat(value);
											if (isNaN(num)) return Promise.reject("Please enter a valid number.");
											if (num < 0) return Promise.reject("Value must be 0 or greater.");
											if (num > 100) return Promise.reject("Target Chargeability cannot exceed 100.");
											const str = String(value);
											if (str.includes(".") && str.split(".")[1]?.length > 2)
												return Promise.reject("Maximum 2 decimal places allowed.");
											return Promise.resolve();
										},
									},
								]}
							>
								<input
									className="ant-input"
									type="number"
									min={0}
									max={100}
									step={0.01}
								/>
							</Form.Item>
						</Col>

					</Row>
				</Form>
			</StyledModal>

			<Modal
				open={deleteModalOpen}
				centered
				title={null}
				footer={[
					<CancelButton
						key="cancel"
						onClick={() => setDeleteModalOpen(false)}
						style={{
							width: 130,
							height: 34,
							borderRadius: 8,
						}}
					>
						No
					</CancelButton>,
					<StyledButton
						key="delete"
						onClick={confirmDelete}
						style={{
							width: 130,
							height: 34,
							borderRadius: 8,
							backgroundColor: "#00685F",
							borderColor: "#00685F",
						}}
					>
						Yes
					</StyledButton>,
				]}
				onCancel={() => setDeleteModalOpen(false)}
			>
				<p style={{ fontWeight: 400, fontSize: "16px", marginBottom: 0 }}>
					Are you sure you want to delete this chargeout rate?
				</p>
			</Modal>
			<Modal
				open={warningModalOpen}
				centered
				footer={[
					<StyledButton
						key="ok"
						onClick={() => setWarningModalOpen(false)}

					>
						OK
					</StyledButton>,
				]}
				onCancel={() => setWarningModalOpen(false)}
			>
				<p style={{ fontWeight: 400, fontSize: "16px", marginBottom: 0 }}>
					{warningMessage}
				</p>
			</Modal>
		</>
	);
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateUserList: setUserList,
		},
		dispatch
	);

const mapStateToProps = (state) => ({
	ClientId: getClientid(state),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null
)(ChargeoutRates);